export const studyBs = {
  common: {
    academy: 'Akademija',
    brand: 'Deenly Akademija',
    studyRoom: 'Radna soba',
    collection: 'Zbirka',
    map: 'Mapa',
    save: 'Sačuvaj',
    cancel: 'Odustani',
    delete: 'Obriši',
    add: 'Dodaj',
    close: 'Zatvori',
    search: 'Pretraži…',
    all: 'Sve',
    loading: 'Učitavam…',
    rename: 'Preimenuj',
    name: 'Naziv',
    edit: 'Uredi',
    write: 'Piši',
    fromCollection: 'Iz Zbirke',
    onMap: 'Na mapu',
    email: 'Email',
    password: 'Šifra',
    cards: '{n} kartica | {n} kartica',
    pages: '{n} strana | {n} strana',
    color: 'Boja {name}',
    colorColon: 'Boja: {name}',
    colors: { teal: 'teal', gold: 'gold', rose: 'rose', sky: 'sky', violet: 'violet', slate: 'slate', mint: 'mint', lilac: 'lilac', white: 'white' },
  },
  errors: {
    network: 'Nema veze sa serverom. Provjeri internet i pokušaj ponovo.',
    tooMany: 'Previše pokušaja. Sačekaj minut pa pokušaj ponovo.',
    generic: 'Nešto nije u redu. Pokušaj ponovo.',
  },
  cardTypes: {
    quran: { label: 'Kur’an', short: 'Ajet' },
    hadith: { label: 'Sunnet', short: 'Hadis' },
    scholar: { label: 'Učenjaci', short: 'Citat' },
    root: { label: 'Korijeni', short: 'Korijen' },
    note: { label: 'Moje', short: 'Bilješka' },
  },
  templates: {
    fiqh: {
      label: 'Fikh pitanje',
      hint: 'Šta je propis o nečemu: dokazi iz Kur’ana i Sunneta, mišljenja učenjaka, tvoj zaključak.',
      lanes: { question: 'Pitanje', quran: 'Kur’an', sunnah: 'Sunnet', opinions: 'Mišljenja učenjaka', conclusion: 'Zaključak' },
    },
    tafsir: {
      label: 'Tefsir ajeta',
      hint: 'Jedan ajet ili odlomak: riječi, povod objave, šta kažu mufessiri, pouke.',
      lanes: { ayah: 'Ajet', words: 'Riječi i korijeni', occasion: 'Povod objave', tafsirs: 'Tefsiri', lessons: 'Pouke' },
    },
    hadith: {
      label: 'Studija hadisa',
      hint: 'Jedan hadis: tekst i izvor, šerh, propisi koji iz njega proizlaze, pouke.',
      lanes: { text: 'Tekst i izvor', sharh: 'Šerh', rulings: 'Propisi iz hadisa', lessons: 'Pouke' },
    },
    free: {
      label: 'Slobodna mapa',
      hint: 'Prazna mapa bez okvira, za sve ostalo.',
    },
  },
  taskColumns: { todo: 'Za uraditi', doing: 'U toku', done: 'Gotovo' },
  card: {
    page: 'str. {page}',
    noteLine: 'Bilješka: {note}',
  },
  due: {
    late: 'kasni {n} d.',
    today: 'danas',
    tomorrow: 'sutra',
    in: 'za {n} d.',
  },
  password: {
    length: 'Najmanje {n} znakova',
    letters: 'Slova',
    numbers: 'Brojevi',
    match: 'Obje šifre se poklapaju',
    failed: 'Nešto nije u redu. Pokušaj ponovo.',
    offline: 'Nema veze sa serverom. Provjeri internet i pokušaj ponovo.',
    tooMany: 'Previše pokušaja. Sačekaj minut pa pokušaj ponovo.',
    meter: 'Jačina šifre',
    show: 'Prikaži šifru',
    hide: 'Sakrij šifru',
    caps: 'Caps Lock je uključen',
    privacy: 'Privatnost',
    strength: ['Preslaba', 'Slaba', 'Solidna', 'Jaka', 'Odlična'],
  },
  auth: {
    panelBadge: 'Deenly panel',
    backToSite: 'Na sajt',
    login: {
      metaTitleAcademy: 'Prijava · Deenly Akademija',
      metaDescAcademy: 'Prijavi se i nastavi učiti na Deenly Akademiji.',
      metaTitle: 'Prijava · Deenly',
      metaDesc: 'Prijava u Deenly panel.',
      academy: {
        title: 'Dobro došli nazad.',
        accent: 'Nastavi gdje si stao.',
        lead: 'Tvoje teme, izvori i čitanje te čekaju.',
        cardTitle: 'Prijava na Akademiju',
      },
      panel: {
        title: 'Dobro došli nazad.',
        accent: 'Uredi. Objavi. Prati.',
        lead: 'Biblioteka, predavanja, feed i analitika Deenlyja, na jednom mjestu.',
        cardTitle: 'Prijava u panel',
      },
      locked: 'Previše pogrešnih pokušaja. Iz sigurnosnih razloga prijava je pauzirana, pokušaj ponovo za {time}.',
      errors: {
        credentials: 'Email ili šifra nisu tačni.',
        invalid: 'Unesi ispravnu email adresu i šifru.',
        network: 'Nema veze sa serverom. Provjeri internet i pokušaj ponovo.',
        server: 'Prijava trenutno ne radi. Pokušaj ponovo za minut.',
      },
      notices: {
        reset: 'Šifra je promijenjena. Prijavi se novom šifrom.',
        expired: 'Sesija je istekla. Prijavi se ponovo.',
      },
      noAccount: 'Nemaš nalog?',
      createFree: 'Napravi ga besplatno',
      teamOnly: 'Pristup imaju samo članovi tima. Nalog otvara administrator.',
      forgot: 'Zaboravljena šifra?',
      retryIn: 'Pokušaj ponovo za {time}',
      submit: 'Prijavi se',
    },
    forgot: {
      metaTitle: 'Zaboravljena šifra · Deenly',
      metaDesc: 'Link za novu šifru na tvoj email.',
      invalidEmail: 'Unesi ispravnu email adresu.',
      title: 'Zaboravljena šifra?',
      accent: 'Nova za minut.',
      lead: 'Upiši email svog naloga i poslat ćemo ti link za novu šifru. Link važi 60 minuta.',
      cardSent: 'Provjeri email',
      cardLink: 'Link za novu šifru',
      sentBody: 'Ako nalog s adresom {email} postoji, upravo smo poslali link za novu šifru. Link važi 60 minuta i radi samo jednom.',
      sentHint: 'Nema ga? Pogledaj i spam, ili zatraži novi za minut.',
      resend: 'Pošalji ponovo',
      backToLogin: 'Nazad na prijavu',
      send: 'Pošalji link',
      remembered: 'Sjetio/la sam se, nazad na prijavu',
    },
    reset: {
      metaTitle: 'Nova šifra · Deenly',
      metaDesc: 'Postavi novu šifru za Deenly.',
      title: 'Nova šifra.',
      accent: 'Jedan korak.',
      lead: 'Nakon promjene, svi uređaji na kojima si prijavljen/a bit će odjavljeni.',
      cardBroken: 'Link nije potpun',
      cardSet: 'Postavi novu šifru',
      hintBroken: 'Otvori link ponovo iz emaila, cijeli, ili zatraži novi.',
      hintAccount: 'Za nalog {email}',
      requestLink: 'Zatraži novi link',
      newPassword: 'Nova šifra',
      repeat: 'Ponovi novu šifru',
      mismatch: 'Šifre se ne poklapaju.',
      submit: 'Sačuvaj novu šifru',
    },
  },
  signup: {
    metaTitle: 'Novi nalog · Deenly Akademija',
    metaDesc: 'Besplatan nalog za Deenly Akademiju: tvoje mjesto za izučavanje islama.',
    title: 'Tvoje mjesto',
    accent: 'za izučavanje islama.',
    lead: 'Ajeti, hadisi i bilješke na jednoj mapi, hatma i knjige koje čitaš, obaveze s fakulteta. Besplatno.',
    cardTitle: 'Novi nalog',
    bullet1: 'Mapa znanja: ajeti, hadisi, tefsir i bilješke na jednom mjestu',
    bullet2: 'Dokazi iz Kur’ana i hadisa, pronađeni po značenju',
    bullet3: 'Hatma, knjige i obaveze s rokovima, svaki dan pred tobom',
    haveAccount: 'Već imaš nalog?',
    signIn: 'Prijavi se',
    firstName: 'Ime',
    lastName: 'Prezime',
    enterFirstName: 'Unesi ime.',
    enterLastName: 'Unesi prezime.',
    repeatPassword: 'Ponovi šifru',
    mismatch: 'Šifre se ne poklapaju.',
    accept: 'Prihvatam {policy}.',
    policy: 'politiku privatnosti',
    confirmTerms: 'Potvrdi da prihvataš politiku privatnosti.',
    submit: 'Napravi nalog',
  },
  layout: {
    closeMenu: 'Zatvori meni',
    today: 'Danas',
    spaces: 'Prostori',
    newSpace: 'Novi prostor',
    spacesFailed: 'Prostori se nisu učitali.',
    logout: 'Odjava',
    dialogSubtitle: 'Predmet s fakulteta ili lični cilj: u njemu su teme, zadaci i čitanje.',
    subject: 'Predmet',
    goal: 'Cilj',
    placeholderGoal: 'npr. Ramazan 1448',
    placeholderSubject: 'npr. Usul el-fikh III',
    create: 'Napravi prostor',
    ideas: {
      usul: 'Usul el-fikh',
      tafsir: 'Tefsir',
      hadith: 'Hadis',
      arabic: 'Arapski jezik',
      ramadan: 'Ramazan',
      khatma: 'Hatma',
      hifz: 'Hifz',
      exam: 'Ispit',
    },
  },
  today: {
    metaTitle: 'Danas · Radna soba · Deenly Akademija',
    metaDesc: 'Tvoji zadaci, čitanje i teme.',
    morning: 'Dobro jutro',
    day: 'Dobar dan',
    evening: 'Dobro veče',
    promptFiqh: 'Pitanje koje istražuješ (npr. „Da li je kamata haram?“)',
    failed: 'Nismo uspjeli učitati Radnu sobu.',
    retry: 'Pokušaj ponovo',
    weekTasks: 'Zadaci ove sedmice',
    allTasks: 'Svi zadaci',
    noTasks: 'Nema zadataka s rokom u narednih sedam dana.',
    doneAria: 'Završeno: {title}',
    inProgress: 'U toku',
    reading: 'Čitanje',
    planTitle: 'Postavi plan čitanja',
    planBody: 'Hatma do kraja ramazana, ili knjiga za ispit: dobit ćeš dnevnu mjeru.',
    addReading: 'Dodaj čitanje',
    continue: 'Nastavi gdje si stao',
    firstTopic: 'Započni prvu temu',
    streak: 'Niz dana čitanja',
    days: 'dan | dana',
    weekAria: 'Ove sedmice: {n} strana | Ove sedmice: {n} strana',
    weekPages: '{n} strana ove sedmice | {n} strana ove sedmice',
    saveTip: 'Ajet sačuvaš i dok čitaš Kur’an: dugme „Sačuvaj“ ispod svakog ajeta.',
  },
  collection: {
    metaTitle: 'Zbirka · Radna soba · Deenly Akademija',
    metaDesc: 'Tvoji ajeti, hadisi, citati i bilješke.',
    subtitle: 'Sve što sačuvaš, jednom, za koliko god tema želiš.',
    newCard: 'Nova kartica',
    noResults: 'Ništa za ovu pretragu.',
    empty: 'Zbirka je prazna.',
    emptyBody: 'Sačuvaj prvi ajet, hadis ili citat iz knjige. Svaka kartica nosi svoj izvor, pa je kasnije možeš citirati.',
  },
  space: {
    fallback: 'Prostor',
    namePrompt: 'Naziv prostora',
    confirmDelete: 'Obrisati prostor „{title}“ sa svim temama, zadacima i čitanjem? Kartice ostaju u Zbirci.',
    confirmDeleteTask: 'Obrisati zadatak?',
    deleteSpace: 'Obriši prostor',
    navAria: 'Prostor',
    topics: 'Teme',
    tasks: 'Zadaci',
    reading: 'Čitanje',
    newTopic: 'Nova tema',
    taskPlaceholder: 'Novi zadatak, npr. „Ispit iz usula“',
    deadline: 'Rok',
    moveLeft: 'Pomjeri lijevo: {title}',
    moveRight: 'Pomjeri desno: {title}',
    khatmaPlan: 'Plan hatme',
    book: 'Knjiga',
    readingEmpty: 'Dodaj hatmu ili knjigu koju čitaš. Ako postaviš datum završetka, dobit ćeš dnevnu mjeru.',
    fiqhLabel: 'Pitanje koje istražuješ',
    topicName: 'Naziv teme',
    placeholderFiqh: 'npr. Da li je kamata haram?',
    placeholderTafsir: 'npr. Ajetul-kursija (2:255)',
    placeholderHadith: 'npr. Hadis o namjerama',
    previewFrames: 'Mapa počinje s ovim okvirima',
    previewEmpty: 'Prazna mapa',
    openMap: 'Otvori mapu',
    task: 'Zadatak',
    status: 'Stanje',
    topic: 'Tema',
    noTopic: 'Bez teme',
    notes: 'Bilješke',
    openTopic: 'Otvori temu',
    bookPlaceholder: 'npr. Ihja ulumid-din, 1. tom',
    khatma: 'Hatma',
    author: 'Autor',
    pageCount: 'Broj strana',
    khatmaInfo: 'Hatma se broji po 604 strane medinskog mushafa; vidjet ćeš i u kojem si džuzu.',
    finishBy: 'Želim završiti do',
    optional: '(nije obavezno)',
    finishHint: 'S datumom dobijaš dnevnu mjeru: koliko strana dnevno da stigneš na vrijeme.',
  },
  reading: {
    confirmDelete: 'Obrisati „{title}“?',
    khatmaJuz: 'Hatma · džuz {juz}',
    until: 'do {date}',
    finished: 'Završeno. Neka je bereket!',
    measureMet: 'Današnja mjera je ispunjena ({n} str.).',
    todayOf: 'Danas: {read} od {target} strana. | Danas: {read} od {target} strana.',
    readToday: 'Danas pročitano: {n} str.',
    reachedPage: 'Stigao/la sam do strane',
    pagePlaceholder: 'Strana (sad {n})',
    plusPages: '+{n} str.',
  },
  picker: {
    title: 'Iz tvoje Zbirke',
    subtitle: 'Klikni karticu da je staviš na mapu.',
    empty: 'Ovdje nema kartica. Dodaj izvor direktno na mapu.',
    onMap: 'Na mapi',
  },
  save: {
    label: 'Sačuvaj u Radnu sobu',
    saved: 'Sačuvano u Zbirku',
  },
  form: {
    confirmDelete: 'Obrisati karticu iz Zbirke? Nestat će i sa svih tema na kojima je.',
    editTitle: 'Uredi karticu',
    addTitle: 'Dodaj izvor',
    intoFrame: 'U okvir „{frame}“',
    toMapAndCollection: 'Na mapu, i u tvoju Zbirku',
    toCollection: 'U tvoju Zbirku',
    kindAria: 'Vrsta izvora',
    findSurah: 'Pronađi suru',
    surahPlaceholder: 'Sura: ime ili broj',
    surahs: 'Sure',
    ayahCount: '{n} ajeta | {n} ajeta',
    noSurah: 'Nema takve sure.',
    surah: 'Sura',
    perCard: 'najviše 20 na kartici',
    from: 'Od',
    to: 'Do',
    loadingAyat: 'Učitavam ajete…',
    searchHadiths: 'Pretraži hadise',
    hadithPlaceholder: 'Pretraži Deenly zbirku: namjere, intention, riba…',
    hadithNote: 'Zbirka je zasad većinom na engleskom. Ne nalaziš hadis? {link}.',
    hadithManual: 'Upiši ga sa izvorom',
    searching: 'Tražim…',
    english: 'engleski',
    noResults: 'Nema rezultata.',
    minLetters: 'Upiši barem tri slova.',
    backToSearch: '← Nazad na pretragu',
    hadithText: 'Tekst hadisa…',
    scholarText: 'Citat ili sažetak onoga što je učenjak rekao…',
    noteText: 'Tvoja bilješka…',
    hadithSource: 'Izvor: zbirka i broj',
    scholarSource: 'Djelo i autor',
    hadithSourcePlaceholder: 'npr. Muslim, 1598',
    scholarSourcePlaceholder: 'npr. Ibn Kudama, El-Mugni',
    page: 'Strana',
    titleOptional: 'Naslov (nije obavezno)',
    addNote: 'Dodaj svoju bilješku uz izvor',
    myNote: 'Moja bilješka',
    notePlaceholder: 'Za šta je ovo dokaz, šta ti je važno…',
    addToMap: 'Dodaj na mapu',
    saveToCollection: 'Sačuvaj u Zbirku',
    deleteFromCollection: 'Obriši iz Zbirke',
  },
  node: {
    notePlaceholder: 'Piši…',
    noteEmpty: 'Dvoklik za pisanje',
    duplicate: 'Dupliraj',
    textPlaceholder: 'Naslov…',
    textEmpty: 'Dvoklik za tekst',
    tidyLabel: 'Poredaj kartice',
    tidy: 'Poredaj',
    deleteFrame: 'Obriši okvir',
    frame: 'Okvir',
    addInto: 'Dodaj u: {title}',
    open: 'Otvori',
    removeFromMap: 'Skini s mape',
  },
  quick: {
    addToMap: 'Dodaj na mapu',
    placeholder: 'Ajet, korijen ili tema…',
    hint: 'Npr. 2:255 · bekare 255-257 · jasin 1 · رحم · strpljenje',
    rootTitle: 'Korijen {root}',
    rootText: 'Riječi iz ovog korijena i koliko se puta javljaju u Kur’anu.',
    surah: 'Sura {n}',
    evidence: 'Pronađi dokaze',
    evidenceHint: 'Stavi na mapu 3 najbliža ajeta i 3 hadisa, svaki u svoj okvir.',
    noResults: 'Ništa za ovo. Probaj referencu (2:255) ili drugu riječ.',
    enter: 'Enter: na mapu',
  },
  explorer: {
    title: 'Istraži',
    tabs: {
      words: 'Riječi',
      tafsir: 'Tefsir',
      translations: 'Prijevodi',
      related: 'Ajeti',
      hadiths: 'Hadisi',
      sharh: 'Šerh',
      lessons: 'Pouke',
      ayat: 'Ajeti',
    },
    surah: 'Sura {n}',
    tafsirName: 'Tefsir el-Muhtasar',
    tafsirTitle: 'Tefsir el-Muhtasar · {ref}',
    tafsirSource: 'Tefsir el-Muhtasar, {ref}',
    translationTitle: 'Prijevod: {name}',
    translationSource: 'Kur’an, {ref}, prijevod: {name}',
    sharhTitle: 'Šerh: {title}',
    sharhSource: 'HadeethEnc.com, objašnjenje hadisa',
    lessonTitle: 'Pouka iz hadisa',
    lessonsTitle: 'Pouke iz hadisa',
    edge: {
      tafsir: 'tefsir',
      translation: 'prijevod',
      root: 'korijen',
      rootOf: 'korijen {root}',
      hadith: 'hadis',
      sharh: 'šerh',
      lesson: 'pouka',
      lessons: 'pouke',
      related: 'srodan ajet',
      ayah: 'ajet',
    },
    backToAyah: 'Nazad na ajet',
    hadithFallback: 'Hadis',
    whatToExplore: 'Šta istražiti',
    failed: 'Nije se učitalo. Pokušaj ponovo.',
    wordsHint: 'Dodirni riječ da vidiš njen korijen kroz cijeli Kur’an.',
    noTafsir: 'Za ovaj ajet nema tefsira na bosanskom.',
    relatedHint: 'Ajeti najbliži po značenju. Povuci na mapu.',
    noRelated: 'Za ovaj ajet nema srodnih ajeta.',
    hadithsHint: 'Hadisi najbliži ovom ajetu po značenju. Povuci na mapu.',
    noHadiths: 'Nema hadisa za ovaj ajet.',
    explanation: 'Objašnjenje hadisa',
    noExplanation: 'Za ovaj hadis nema objašnjenja.',
    allLessons: 'Sve pouke kao jedna bilješka',
    noLessons: 'Za ovaj hadis nema pouka.',
    ayatHint: 'Ajeti najbliži ovom hadisu po značenju.',
    noAyat: 'Nema srodnih ajeta.',
    rootOnMap: 'Korijen na mapu',
    rootStats: '{times} u {ayahs}, u {surahs}',
    rootTimes: '{n} puta | {n} puta',
    rootAyahs: '{n} ajeta | {n} ajeta',
    rootSurahs: '{n} sura | {n} sura',
    previous: 'Prethodni',
    next: 'Sljedeći',
  },
  topic: {
    fallback: 'Tema',
    newFrame: 'Novi okvir',
    added: 'Dodano na mapu i u Zbirku.',
    removedCount: 'Obrisano: {n}.',
    cardRemoved: 'Kartica je skinuta s mape (ostaje u Zbirci).',
    removed: 'Obrisano.',
    confirmDelete: 'Obrisati temu i njenu mapu? Kartice ostaju u Zbirci.',
    restOfMap: 'Ostalo na mapi',
    copied: 'Kopirano. Zalijepi u Word ili Google Docs.',
    tools: {
      search: 'Pronađi i dodaj',
      note: 'Bilješka',
      text: 'Tekst',
      frame: 'Okvir',
      ayah: 'Ajet',
      hadith: 'Hadis',
      quote: 'Citat učenjaka',
    },
    addHere: 'Dodaj ovdje',
    edgePlaceholder: 'npr. dokazuje, objašnjava',
    deleteArrow: 'Obriši strelicu',
    emptyTitle: 'Tvoja mapa je spremna.',
    tipSearch: 'Pritisni / i upiši ajet (2:255, bekare 255), korijen ili temu.',
    tipExplore: 'Izaberi ajet na mapi: otvoriće se riječi, tefsir, prijevodi i srodni ajeti.',
    tipPlus: 'Klikni ＋ u okviru da dodaš ajet, hadis ili citat baš tu.',
    tipDouble: 'Dvoklikni bilo gdje na mapi za bilješku, tekst ili novi okvir.',
    tipArrow: 'Povuci od tačke na rubu kartice do druge: dobiješ strelicu.',
    copyAsText: 'Kopiraj kao tekst',
    emptyDoc: 'Mapa je još prazna.',
    back: 'Nazad',
    document: 'Dokument',
    presentTitle: 'Prezentiraj okvire kao slajdove',
    present: 'Prezentiraj',
    deleteTopic: 'Obriši temu',
    toolsAria: 'Alati',
    zoomOut: 'Umanji',
    zoomIn: 'Uvećaj',
    fitAll: 'Prikaži sve',
    zoomHint: 'Dvoklik: dodaj · Shift + povuci: označi više · Delete: obriši',
    presentationAria: 'Prezentacija',
    prevFrame: 'Prethodni okvir',
    nextFrame: 'Sljedeći okvir',
    finish: 'Završi',
    undo: 'Vrati',
    myNote: 'Moja bilješka',
    wordByWord: 'Riječ po riječ',
    tafsir: 'Tefsir',
    link: 'Link',
  },
};
